import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { type TextFieldProps, TextField } from '../TextField';

type FormTextFieldProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  TextFieldProps;

function FormTextField<TFieldValues extends FieldValues = FieldValues>(
  props: FormTextFieldProps<TFieldValues>,
) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <TextField
      {...props}
      {...field}
      type={props?.type ?? 'text'}
      error={!!error}
      helperText={error?.message ?? props.helperText ?? null}
      required={Boolean(props.rules?.required ?? props.required)}
      inputRef={ref}
    />
  );
}

export type { FormTextFieldProps };
export { FormTextField };
